import useMediaQuery from '@material-ui/core/useMediaQuery';

import OrdersKanbanTabs from '../orders-kanban-tabs';
import { SwipeableViews } from '../common/swipeable-views';
import OrdersKanbanAdvancedFiltersToolbar from '../orders-kanban-advanced-filters-toolbar';

import { useTLang } from 'intl/intl';

import useStyles from './OrdersKanbanLayout.styles';

function OrdersKanbanLayout({ children, index, onChangeIndex, totalColumns }) {
  const title = useTLang({ id: 'ordersKanbanPage.title' });
  const hasAutoAccept = totalColumns === 2;
  const componentClasses = useStyles({ totalColumns, hasAutoAccept });
  const isMdUp = useMediaQuery(theme => theme.breakpoints.up('md'));

  return (
    <div className={componentClasses.root}>
      <OrdersKanbanAdvancedFiltersToolbar title={title} />
      <div className={componentClasses.board}>{children}</div>
      <OrdersKanbanTabs />
      <SwipeableViews
        index={index}
        onChangeIndex={onChangeIndex}
        className={componentClasses.swipeableViewsRoot}
      >
        {children}
      </SwipeableViews>
    </div>
  );
}

export default OrdersKanbanLayout;
